export const PERMISSION_KEYS = {
  HR: 'hr',
  HR_MIS: 'hr.mis',
  HR_UT: 'hr.ut',
  HR_ECARD: 'hr.e-card',
  HR_ICR: 'hr.icr',
  HR_DOC: 'hr.doc',
  HR_LETTER: 'hr.letter',
} as const;

export const ACTIONS = {
  SHARE: 'share',
  DOWNLOAD: 'download',
  DOWNLOAD_ALL: 'download-all',
} as const;